import { useReactiveVar } from '@apollo/client';
import { clsx } from 'clsx';
import { useState } from 'react';
import { LayoutCard } from '@/components/layout/card.tsx';
import { getPageMeta } from '@/routes-utils/get-page-meta.ts';
import { authCard, authContent, welcomeCard } from '../_auth/page.css.ts';
import { SeoHandle } from '../sitemap[.]xml/generate-sitemap.ts';
import { ConfirmResetPasswordForm } from './confirm-reset-password-form.tsx';
import { PasswordChanged } from './password-changed.tsx';
import { ResetPasswordForm } from './reset-password-form.tsx';
import { resetPasswordStepVar } from './reset-password-step-var.ts';

export const handle: SeoHandle = {
  sitemap: true,
};

export const meta = () =>
  getPageMeta({
    url: 'https://synoptic.com/auth/reset-password',
  });

export const action = () => new Response(null, { status: 405 });

export default function ResetPassword() {
  const step = useReactiveVar(resetPasswordStepVar);
  const [username, setUsername] = useState('');

  const handleResetPassword = (username: string) => {
    setUsername(username);
    resetPasswordStepVar('confirmResetPassword');
  };

  const handleConfirmResetPassword = () => {
    resetPasswordStepVar('passwordChanged');
  };

  return (
    <LayoutCard className={clsx(authCard, welcomeCard)}>
      <div className={authContent}>
        {step === 'resetPassword' && (
          <ResetPasswordForm onResetPassword={handleResetPassword} />
        )}
        {step === 'confirmResetPassword' && (
          <ConfirmResetPasswordForm
            onConfirmResetPassword={handleConfirmResetPassword}
            username={username}
          />
        )}
        {step === 'passwordChanged' && <PasswordChanged />}
      </div>
    </LayoutCard>
  );
}
